<template>
  <div>
    <b-modal
      v-model="modalShow"
      size="lg"
      title="Import"
      :static="true"
      :lazy="true"
      hide-footer
    >
      <div class="modal-body">
        <form class="">
          <div class="form-row">
            <div class="form-group col">
              <label class="form-label">Type</label>
              <b-form-select v-model="type" :options="fileTypes"></b-form-select>
            </div>

            <div class="form-group col">
              <label class="form-label">Directory</label>
              <b-form-input v-model="directory"></b-form-input>
            </div>

            <div class="form-group col">
              <label class="form-label">File</label>
              <div class="form-file">
                <input ref="fileInput" name="file" class="form-control-file" multiple type="file" required>
              </div>
            </div>
            <div class="d-flex align-items-end justify-content-end form-group col-sm-2">
              <button type="button" @click="uploadFile" class="btn btn-success btn-sm">Upload file</button>
            </div>
          </div>
        </form>
      </div>
    </b-modal>
  </div>
</template>

<script>
import axios from "axios";

export default {
  data() {
    return {
      modalShow: false,
      directory: null,
      games: [],
      fileTypes: [],
      type: null
    }
  },
  props: [
    'isUploaded'
  ],
  methods: {
    uploadFile() {
      const fd = new FormData();
      fd.append('type', this.type);
      fd.append('directory', this.directory);

      for (let i = 0; i < this.$refs.fileInput.files.length; i++) {
        fd.append('files_' + i, this.$refs.fileInput.files[i]);
      }

      this
        .$http({
          url: '/api/v1/files',
          method: 'POST',
          data: fd,
          headers: { "Content-Type": "multipart/form-data" },
        })
        .then(() => {
          this.modalShow = false;
          this.$emit('onComplete');
        })
        .catch((err) => {
          this.$toastr.e(err.response.data.error);
        })
    },
    loadFileTypes() {
      this.fileTypes = [];
      this
          .$http({
            url: '/api/v1/file/types',
            method: 'GET',
            cancelToken: new axios.CancelToken(c => {self.cancel = c})
          })
          .then(resp => {
            this.fileTypes = resp.data.map(item => {return item});
          })
          .catch((err) => {
            this.fileTypes = [];
            this.error = err;
          })
          .finally(() => {
          });
    },
    toggle() {
      this.modalShow = !this.modalShow;
    },
  },
  mounted() {
    this.loadFileTypes();
  }
}
</script>
